import React, { useContext } from 'react'
import { ResponsiveBox } from '@usap/uicomponents'
import { TagInput } from '@usap/widgets'
import { SearchContext } from '../../common/context/SearchContextProvider'
import seoIds from '../../../../config/seoIds'

export default function SelectedRefinements(props) {
  const { toggleRefine } = props
  const { searchState: { products } } = useContext(SearchContext)
  const { refinements } = products
  const { selected = [] } = refinements
  const hasSelected = Boolean(selected && selected.length)

  return (
    <ResponsiveBox
      id="refinedItemsSection"
      wrap
      align="start"
      margin={{ vertical: 'xsmall' }}
      fxPad={{ large: '0px', other: { horizontal: 'medium' } }}
    >
      {hasSelected
        && selected.map(({ name, value, link }, index) => {
          const mapKey = seoIds.refinedItem.replace('{{key}}', index)

          return (
            <TagInput
              id={mapKey}
              key={name}
              onRemove={() => toggleRefine(link, value)}
            >
              {`${value} (${name})`}
            </TagInput>
          )
        })}
    </ResponsiveBox>
  )
}
